import { z } from "zod";

export type UserProfile = z.infer<typeof UserProfileSchema>;
export const UserProfileSchema = z.object({
  id: z.string().nullable(),
  id_account: z.number().nullable(),
  username: z.string(),
  email: z.string(),
  userType: z.string(),
  langCd: z.string(),
  icon: z.string(),
  qr: z.string(),
  emailNotification: z.boolean(),
  pushNotification: z.boolean(),
  snsNotification: z.boolean(),
  snsAccessId: z.string(),
  snsType: z.string(),
  isOfficial: z.boolean(),
  activationType: z.string(),
  signUpAt: z.string(),
  sandboxType: z.string().nullable(),
});
